import {
  anAddTagToInsight,
  mockAddTagToInsightOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const addTagToInsightResponse = {
  __typename: 'Mutation' as const,
  addTagToInsight: anAddTagToInsight(),
};

export const handlers = [
  mockAddTagToInsightOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: addTagToInsightResponse,
      });
    }
  ),
];
